/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CharterInvoiceGroupsQueryVariables = Types.Exact<{
  charterId: Types.Scalars['Long']['input'];
  declarationId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type CharterInvoiceGroupsQuery = {
  __typename?: 'Query',
  charter: {
    __typename?: 'PurchaseCharter',
    id: number,
    invoiceGroups: Array<{
      __typename?: 'InvoiceGroup',
      invoiceGroupType?: {
        __typename?: 'InvoiceGroupType',
        id: number,
        name: string
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      declaration?: {
        __typename?: 'PurchaseDeclaration',
        id: number,
        createdOn?: number | null,
        closedOn?: number | null,
        financiallyReadiedOn?: number | null,
        totalPriceExcVAT?: number | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>,
        invoiceGroupType?: {
          __typename?: 'InvoiceGroupType',
          id: number,
          name: string
        } | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          approved?: boolean | null,
          quantity?: number | null,
          totalPriceExcVAT?: number | null,
          totalPriceIncVAT?: number | null,
          unit?: string | null,
          invoiceReference?: string | null,
          description?: string | null,
          unexpected?: boolean | null,
          summary?: string | null,
          calculationSummary?: string | null,
          price?: {
            __typename?: 'Price',
            value?: number | null,
            currency?: {
              __typename?: 'Currency',
              rate?: number | null,
              isoCode?: string | null,
              symbol?: string | null
            } | null
          } | null,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            price?: number | null,
            quantity?: number | null
          } | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_de?: string | null,
            title_nl?: string | null
          } | null,
          debtor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          creditor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          agreement?: {
            __typename?: 'AddressCommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CleaningAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DailyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FeetAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolineAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HourlyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'LumpsumAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'OogAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PJKAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReeferAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'RentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ShipAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TeuAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TextAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterwayAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | null,
          vatCode?: {
            __typename?: 'VATCode',
            id: number,
            label?: string | null,
            percentage: number
          } | null,
          declaration?: {
            __typename?: 'PurchaseDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | {
            __typename?: 'SalesDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | null
        }>
      } | {
        __typename?: 'SalesDeclaration',
        id: number,
        createdOn?: number | null,
        closedOn?: number | null,
        financiallyReadiedOn?: number | null,
        totalPriceExcVAT?: number | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>,
        invoiceGroupType?: {
          __typename?: 'InvoiceGroupType',
          id: number,
          name: string
        } | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          approved?: boolean | null,
          quantity?: number | null,
          totalPriceExcVAT?: number | null,
          totalPriceIncVAT?: number | null,
          unit?: string | null,
          invoiceReference?: string | null,
          description?: string | null,
          unexpected?: boolean | null,
          summary?: string | null,
          calculationSummary?: string | null,
          price?: {
            __typename?: 'Price',
            value?: number | null,
            currency?: {
              __typename?: 'Currency',
              rate?: number | null,
              isoCode?: string | null,
              symbol?: string | null
            } | null
          } | null,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            price?: number | null,
            quantity?: number | null
          } | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_de?: string | null,
            title_nl?: string | null
          } | null,
          debtor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          creditor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          agreement?: {
            __typename?: 'AddressCommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CleaningAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DailyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FeetAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolineAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HourlyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'LumpsumAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'OogAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PJKAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReeferAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'RentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ShipAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TeuAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TextAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterwayAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | null,
          vatCode?: {
            __typename?: 'VATCode',
            id: number,
            label?: string | null,
            percentage: number
          } | null,
          declaration?: {
            __typename?: 'PurchaseDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | {
            __typename?: 'SalesDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | null
        }>
      } | null,
      agreements: Array<{
        __typename?: 'InvoiceGroupAgreement',
        ready: boolean,
        manualActionRequired: boolean,
        agreement: {
          __typename?: 'AddressCommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'BlockFreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'BunkerAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'CleaningAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'CommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DailyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DangerousGoodAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DeadfreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DemurrageAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DemurrageCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'FeetAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'FreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'GasolineAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'GasolinePriceAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'HoseRentalAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'HourlyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'LumpsumAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'MultiCargoAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'MultiOrderAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'NitrogenPurgingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'OogAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'PJKAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'PostCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'ReeferAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'RentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'ReturnFreightDiscountAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'ShipAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'SupplementaryHeatingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'TeuAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'TextAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WaterLevelAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WaterwayAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WeightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WeightRangeAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        }
      }>
    }>
  } | {
    __typename?: 'SalesCharter',
    id: number,
    invoiceGroups: Array<{
      __typename?: 'InvoiceGroup',
      invoiceGroupType?: {
        __typename?: 'InvoiceGroupType',
        id: number,
        name: string
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      declaration?: {
        __typename?: 'PurchaseDeclaration',
        id: number,
        createdOn?: number | null,
        closedOn?: number | null,
        financiallyReadiedOn?: number | null,
        totalPriceExcVAT?: number | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>,
        invoiceGroupType?: {
          __typename?: 'InvoiceGroupType',
          id: number,
          name: string
        } | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          approved?: boolean | null,
          quantity?: number | null,
          totalPriceExcVAT?: number | null,
          totalPriceIncVAT?: number | null,
          unit?: string | null,
          invoiceReference?: string | null,
          description?: string | null,
          unexpected?: boolean | null,
          summary?: string | null,
          calculationSummary?: string | null,
          price?: {
            __typename?: 'Price',
            value?: number | null,
            currency?: {
              __typename?: 'Currency',
              rate?: number | null,
              isoCode?: string | null,
              symbol?: string | null
            } | null
          } | null,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            price?: number | null,
            quantity?: number | null
          } | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_de?: string | null,
            title_nl?: string | null
          } | null,
          debtor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          creditor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          agreement?: {
            __typename?: 'AddressCommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CleaningAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DailyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FeetAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolineAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HourlyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'LumpsumAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'OogAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PJKAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReeferAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'RentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ShipAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TeuAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TextAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterwayAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | null,
          vatCode?: {
            __typename?: 'VATCode',
            id: number,
            label?: string | null,
            percentage: number
          } | null,
          declaration?: {
            __typename?: 'PurchaseDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | {
            __typename?: 'SalesDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | null
        }>
      } | {
        __typename?: 'SalesDeclaration',
        id: number,
        createdOn?: number | null,
        closedOn?: number | null,
        financiallyReadiedOn?: number | null,
        totalPriceExcVAT?: number | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>,
        invoiceGroupType?: {
          __typename?: 'InvoiceGroupType',
          id: number,
          name: string
        } | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          approved?: boolean | null,
          quantity?: number | null,
          totalPriceExcVAT?: number | null,
          totalPriceIncVAT?: number | null,
          unit?: string | null,
          invoiceReference?: string | null,
          description?: string | null,
          unexpected?: boolean | null,
          summary?: string | null,
          calculationSummary?: string | null,
          price?: {
            __typename?: 'Price',
            value?: number | null,
            currency?: {
              __typename?: 'Currency',
              rate?: number | null,
              isoCode?: string | null,
              symbol?: string | null
            } | null
          } | null,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            price?: number | null,
            quantity?: number | null
          } | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_de?: string | null,
            title_nl?: string | null
          } | null,
          debtor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          creditor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          agreement?: {
            __typename?: 'AddressCommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CleaningAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'CommissionAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DailyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FeetAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'FreightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolineAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'HourlyAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'LumpsumAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'OogAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PJKAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReeferAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'RentAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'ShipAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TeuAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'TextAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WaterwayAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number,
            type: Types.AgreementTypeEnum,
            description?: string | null,
            summary?: string | null,
            calculationMethod?: {
              __typename?: 'CargoQuantityCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'CoveredByFreightPriceCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'DemurrageCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'GasoilConsumptionCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'LumpsumCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ManualCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'PercentageOnAgreementsCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'QuantityUnitCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'ReferenceRateCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'StaffelCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TieredCalculationMethod',
              summary?: string | null
            } | {
              __typename?: 'TimeUnitCalculationMethod',
              summary?: string | null
            } | null
          } | null,
          vatCode?: {
            __typename?: 'VATCode',
            id: number,
            label?: string | null,
            percentage: number
          } | null,
          declaration?: {
            __typename?: 'PurchaseDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | {
            __typename?: 'SalesDeclaration',
            id: number,
            charter?: {
              __typename?: 'PurchaseCharter',
              type: Types.CharterType,
              id: number,
              charterNumber: string
            } | {
              __typename?: 'SalesCharter',
              blDate?: number | null,
              type: Types.CharterType,
              id: number,
              charterNumber: string,
              status: {
                __typename?: 'SalesCharterStatusType',
                name: Types.SalesCharterStatus,
                color: string,
                languageKeyPrefix: string
              }
            } | null,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          } | null
        }>
      } | null,
      agreements: Array<{
        __typename?: 'InvoiceGroupAgreement',
        ready: boolean,
        manualActionRequired: boolean,
        agreement: {
          __typename?: 'AddressCommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'BlockFreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'BunkerAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'CleaningAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'CommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DailyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DangerousGoodAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DeadfreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DemurrageAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'DemurrageCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'FeetAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'FreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'GasolineAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'GasolinePriceAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'HoseRentalAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'HourlyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'LumpsumAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'MultiCargoAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'MultiOrderAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'NitrogenPurgingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'OogAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'PJKAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'PostCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'ReeferAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'RentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'ReturnFreightDiscountAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'ShipAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'SupplementaryHeatingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'TeuAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'TextAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WaterLevelAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WaterwayAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WeightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        } | {
          __typename?: 'WeightRangeAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          priority: number,
          summary?: string | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'DemurrageCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'LumpsumCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ManualCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'StaffelCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TieredCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            summary?: string | null,
            type: Types.CalculationMethodType
          } | null,
          invoiceGroupType?: {
            __typename?: 'InvoiceGroupType',
            id: number,
            name: string
          } | null
        }
      }>
    }>
  }
};

export type DeclarationLinesInvoiceGroupsQueryVariables = Types.Exact<{
  charterId: Types.Scalars['Long']['input'];
  from?: Types.InputMaybe<Types.Scalars['Instant']['input']>;
  to?: Types.InputMaybe<Types.Scalars['Instant']['input']>;
  declarationId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type DeclarationLinesInvoiceGroupsQuery = {
  __typename?: 'Query',
  charter: {
    __typename?: 'PurchaseCharter',
    id: number,
    ships?: Array<{
      __typename?: 'Ship',
      id: number
    }> | null,
    contract?: {
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      isDeclarable?: boolean | null,
      currency?: {
        __typename?: 'Currency',
        isoCode?: string | null
      } | null
    } | null,
    invoiceGroups: Array<{
      __typename?: 'InvoiceGroup',
      invoiceGroupType?: {
        __typename?: 'InvoiceGroupType',
        id: number,
        name: string
      } | null,
      declaration?: {
        __typename?: 'PurchaseDeclaration',
        id: number,
        closedOn?: number | null,
        remark?: string | null,
        declarationValues?: Array<{
          __typename?: 'DeclarationValue',
          id: number,
          quantity?: number | null,
          price?: number | null,
          agreement: {
            __typename?: 'AddressCommissionAgreement',
            id: number
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'CleaningAgreement',
            id: number
          } | {
            __typename?: 'CommissionAgreement',
            id: number
          } | {
            __typename?: 'DailyAgreement',
            id: number
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number
          } | {
            __typename?: 'DemurrageAgreement',
            id: number
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number
          } | {
            __typename?: 'FeetAgreement',
            id: number
          } | {
            __typename?: 'FreightAgreement',
            id: number
          } | {
            __typename?: 'GasolineAgreement',
            id: number
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number
          } | {
            __typename?: 'HourlyAgreement',
            id: number
          } | {
            __typename?: 'LumpsumAgreement',
            id: number
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number
          } | {
            __typename?: 'OogAgreement',
            id: number
          } | {
            __typename?: 'PJKAgreement',
            id: number
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number
          } | {
            __typename?: 'ReeferAgreement',
            id: number
          } | {
            __typename?: 'RentAgreement',
            id: number
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number
          } | {
            __typename?: 'ShipAgreement',
            id: number
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number
          } | {
            __typename?: 'TeuAgreement',
            id: number
          } | {
            __typename?: 'TextAgreement',
            id: number
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number
          } | {
            __typename?: 'WaterwayAgreement',
            id: number
          } | {
            __typename?: 'WeightAgreement',
            id: number
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number
          }
        } | null> | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            id: number,
            quantity?: number | null,
            price?: number | null,
            agreement: {
              __typename?: 'AddressCommissionAgreement',
              id: number
            } | {
              __typename?: 'BlockFreightAgreement',
              id: number
            } | {
              __typename?: 'BunkerAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'CleaningAgreement',
              id: number
            } | {
              __typename?: 'CommissionAgreement',
              id: number
            } | {
              __typename?: 'DailyAgreement',
              id: number
            } | {
              __typename?: 'DangerousGoodAgreement',
              id: number
            } | {
              __typename?: 'DeadfreightAgreement',
              id: number
            } | {
              __typename?: 'DemurrageAgreement',
              id: number
            } | {
              __typename?: 'DemurrageCalculationAgreement',
              id: number
            } | {
              __typename?: 'FeetAgreement',
              id: number
            } | {
              __typename?: 'FreightAgreement',
              id: number
            } | {
              __typename?: 'GasolineAgreement',
              id: number
            } | {
              __typename?: 'GasolinePriceAgreement',
              id: number
            } | {
              __typename?: 'HoseRentalAgreement',
              id: number
            } | {
              __typename?: 'HourlyAgreement',
              id: number
            } | {
              __typename?: 'LumpsumAgreement',
              id: number
            } | {
              __typename?: 'MultiCargoAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'MultiOrderAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'NitrogenPurgingAgreement',
              id: number
            } | {
              __typename?: 'OogAgreement',
              id: number
            } | {
              __typename?: 'PJKAgreement',
              id: number
            } | {
              __typename?: 'PostCalculationAgreement',
              id: number
            } | {
              __typename?: 'ReeferAgreement',
              id: number
            } | {
              __typename?: 'RentAgreement',
              id: number
            } | {
              __typename?: 'ReturnFreightDiscountAgreement',
              id: number
            } | {
              __typename?: 'ShipAgreement',
              id: number
            } | {
              __typename?: 'SupplementaryHeatingAgreement',
              id: number
            } | {
              __typename?: 'TeuAgreement',
              id: number
            } | {
              __typename?: 'TextAgreement',
              id: number
            } | {
              __typename?: 'WaterLevelAgreement',
              id: number
            } | {
              __typename?: 'WaterwayAgreement',
              id: number
            } | {
              __typename?: 'WeightAgreement',
              id: number
            } | {
              __typename?: 'WeightRangeAgreement',
              id: number
            }
          } | null
        }>
      } | {
        __typename?: 'SalesDeclaration',
        id: number,
        closedOn?: number | null,
        remark?: string | null,
        declarationValues?: Array<{
          __typename?: 'DeclarationValue',
          id: number,
          quantity?: number | null,
          price?: number | null,
          agreement: {
            __typename?: 'AddressCommissionAgreement',
            id: number
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'CleaningAgreement',
            id: number
          } | {
            __typename?: 'CommissionAgreement',
            id: number
          } | {
            __typename?: 'DailyAgreement',
            id: number
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number
          } | {
            __typename?: 'DemurrageAgreement',
            id: number
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number
          } | {
            __typename?: 'FeetAgreement',
            id: number
          } | {
            __typename?: 'FreightAgreement',
            id: number
          } | {
            __typename?: 'GasolineAgreement',
            id: number
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number
          } | {
            __typename?: 'HourlyAgreement',
            id: number
          } | {
            __typename?: 'LumpsumAgreement',
            id: number
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number
          } | {
            __typename?: 'OogAgreement',
            id: number
          } | {
            __typename?: 'PJKAgreement',
            id: number
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number
          } | {
            __typename?: 'ReeferAgreement',
            id: number
          } | {
            __typename?: 'RentAgreement',
            id: number
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number
          } | {
            __typename?: 'ShipAgreement',
            id: number
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number
          } | {
            __typename?: 'TeuAgreement',
            id: number
          } | {
            __typename?: 'TextAgreement',
            id: number
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number
          } | {
            __typename?: 'WaterwayAgreement',
            id: number
          } | {
            __typename?: 'WeightAgreement',
            id: number
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number
          }
        } | null> | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            id: number,
            quantity?: number | null,
            price?: number | null,
            agreement: {
              __typename?: 'AddressCommissionAgreement',
              id: number
            } | {
              __typename?: 'BlockFreightAgreement',
              id: number
            } | {
              __typename?: 'BunkerAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'CleaningAgreement',
              id: number
            } | {
              __typename?: 'CommissionAgreement',
              id: number
            } | {
              __typename?: 'DailyAgreement',
              id: number
            } | {
              __typename?: 'DangerousGoodAgreement',
              id: number
            } | {
              __typename?: 'DeadfreightAgreement',
              id: number
            } | {
              __typename?: 'DemurrageAgreement',
              id: number
            } | {
              __typename?: 'DemurrageCalculationAgreement',
              id: number
            } | {
              __typename?: 'FeetAgreement',
              id: number
            } | {
              __typename?: 'FreightAgreement',
              id: number
            } | {
              __typename?: 'GasolineAgreement',
              id: number
            } | {
              __typename?: 'GasolinePriceAgreement',
              id: number
            } | {
              __typename?: 'HoseRentalAgreement',
              id: number
            } | {
              __typename?: 'HourlyAgreement',
              id: number
            } | {
              __typename?: 'LumpsumAgreement',
              id: number
            } | {
              __typename?: 'MultiCargoAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'MultiOrderAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'NitrogenPurgingAgreement',
              id: number
            } | {
              __typename?: 'OogAgreement',
              id: number
            } | {
              __typename?: 'PJKAgreement',
              id: number
            } | {
              __typename?: 'PostCalculationAgreement',
              id: number
            } | {
              __typename?: 'ReeferAgreement',
              id: number
            } | {
              __typename?: 'RentAgreement',
              id: number
            } | {
              __typename?: 'ReturnFreightDiscountAgreement',
              id: number
            } | {
              __typename?: 'ShipAgreement',
              id: number
            } | {
              __typename?: 'SupplementaryHeatingAgreement',
              id: number
            } | {
              __typename?: 'TeuAgreement',
              id: number
            } | {
              __typename?: 'TextAgreement',
              id: number
            } | {
              __typename?: 'WaterLevelAgreement',
              id: number
            } | {
              __typename?: 'WaterwayAgreement',
              id: number
            } | {
              __typename?: 'WeightAgreement',
              id: number
            } | {
              __typename?: 'WeightRangeAgreement',
              id: number
            }
          } | null
        }>
      } | null,
      agreements: Array<{
        __typename?: 'InvoiceGroupAgreement',
        agreement: {
          __typename?: 'AddressCommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'BlockFreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'BunkerAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'CleaningAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'CommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DailyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DangerousGoodAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DeadfreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DemurrageAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DemurrageCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'FeetAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'FreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'GasolineAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'GasolinePriceAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'HoseRentalAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'HourlyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'LumpsumAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'MultiCargoAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'MultiOrderAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'NitrogenPurgingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'OogAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'PJKAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'PostCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'ReeferAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'RentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'ReturnFreightDiscountAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'ShipAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'SupplementaryHeatingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'TeuAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'TextAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WaterLevelAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WaterwayAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WeightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WeightRangeAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        }
      }>
    }>
  } | {
    __typename?: 'SalesCharter',
    id: number,
    contract?: {
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      isDeclarable?: boolean | null,
      currency?: {
        __typename?: 'Currency',
        isoCode?: string | null
      } | null
    } | null,
    invoiceGroups: Array<{
      __typename?: 'InvoiceGroup',
      invoiceGroupType?: {
        __typename?: 'InvoiceGroupType',
        id: number,
        name: string
      } | null,
      declaration?: {
        __typename?: 'PurchaseDeclaration',
        id: number,
        closedOn?: number | null,
        remark?: string | null,
        declarationValues?: Array<{
          __typename?: 'DeclarationValue',
          id: number,
          quantity?: number | null,
          price?: number | null,
          agreement: {
            __typename?: 'AddressCommissionAgreement',
            id: number
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'CleaningAgreement',
            id: number
          } | {
            __typename?: 'CommissionAgreement',
            id: number
          } | {
            __typename?: 'DailyAgreement',
            id: number
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number
          } | {
            __typename?: 'DemurrageAgreement',
            id: number
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number
          } | {
            __typename?: 'FeetAgreement',
            id: number
          } | {
            __typename?: 'FreightAgreement',
            id: number
          } | {
            __typename?: 'GasolineAgreement',
            id: number
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number
          } | {
            __typename?: 'HourlyAgreement',
            id: number
          } | {
            __typename?: 'LumpsumAgreement',
            id: number
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number
          } | {
            __typename?: 'OogAgreement',
            id: number
          } | {
            __typename?: 'PJKAgreement',
            id: number
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number
          } | {
            __typename?: 'ReeferAgreement',
            id: number
          } | {
            __typename?: 'RentAgreement',
            id: number
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number
          } | {
            __typename?: 'ShipAgreement',
            id: number
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number
          } | {
            __typename?: 'TeuAgreement',
            id: number
          } | {
            __typename?: 'TextAgreement',
            id: number
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number
          } | {
            __typename?: 'WaterwayAgreement',
            id: number
          } | {
            __typename?: 'WeightAgreement',
            id: number
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number
          }
        } | null> | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            id: number,
            quantity?: number | null,
            price?: number | null,
            agreement: {
              __typename?: 'AddressCommissionAgreement',
              id: number
            } | {
              __typename?: 'BlockFreightAgreement',
              id: number
            } | {
              __typename?: 'BunkerAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'CleaningAgreement',
              id: number
            } | {
              __typename?: 'CommissionAgreement',
              id: number
            } | {
              __typename?: 'DailyAgreement',
              id: number
            } | {
              __typename?: 'DangerousGoodAgreement',
              id: number
            } | {
              __typename?: 'DeadfreightAgreement',
              id: number
            } | {
              __typename?: 'DemurrageAgreement',
              id: number
            } | {
              __typename?: 'DemurrageCalculationAgreement',
              id: number
            } | {
              __typename?: 'FeetAgreement',
              id: number
            } | {
              __typename?: 'FreightAgreement',
              id: number
            } | {
              __typename?: 'GasolineAgreement',
              id: number
            } | {
              __typename?: 'GasolinePriceAgreement',
              id: number
            } | {
              __typename?: 'HoseRentalAgreement',
              id: number
            } | {
              __typename?: 'HourlyAgreement',
              id: number
            } | {
              __typename?: 'LumpsumAgreement',
              id: number
            } | {
              __typename?: 'MultiCargoAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'MultiOrderAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'NitrogenPurgingAgreement',
              id: number
            } | {
              __typename?: 'OogAgreement',
              id: number
            } | {
              __typename?: 'PJKAgreement',
              id: number
            } | {
              __typename?: 'PostCalculationAgreement',
              id: number
            } | {
              __typename?: 'ReeferAgreement',
              id: number
            } | {
              __typename?: 'RentAgreement',
              id: number
            } | {
              __typename?: 'ReturnFreightDiscountAgreement',
              id: number
            } | {
              __typename?: 'ShipAgreement',
              id: number
            } | {
              __typename?: 'SupplementaryHeatingAgreement',
              id: number
            } | {
              __typename?: 'TeuAgreement',
              id: number
            } | {
              __typename?: 'TextAgreement',
              id: number
            } | {
              __typename?: 'WaterLevelAgreement',
              id: number
            } | {
              __typename?: 'WaterwayAgreement',
              id: number
            } | {
              __typename?: 'WeightAgreement',
              id: number
            } | {
              __typename?: 'WeightRangeAgreement',
              id: number
            }
          } | null
        }>
      } | {
        __typename?: 'SalesDeclaration',
        id: number,
        closedOn?: number | null,
        remark?: string | null,
        declarationValues?: Array<{
          __typename?: 'DeclarationValue',
          id: number,
          quantity?: number | null,
          price?: number | null,
          agreement: {
            __typename?: 'AddressCommissionAgreement',
            id: number
          } | {
            __typename?: 'BlockFreightAgreement',
            id: number
          } | {
            __typename?: 'BunkerAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'CleaningAgreement',
            id: number
          } | {
            __typename?: 'CommissionAgreement',
            id: number
          } | {
            __typename?: 'DailyAgreement',
            id: number
          } | {
            __typename?: 'DangerousGoodAgreement',
            id: number
          } | {
            __typename?: 'DeadfreightAgreement',
            id: number
          } | {
            __typename?: 'DemurrageAgreement',
            id: number
          } | {
            __typename?: 'DemurrageCalculationAgreement',
            id: number
          } | {
            __typename?: 'FeetAgreement',
            id: number
          } | {
            __typename?: 'FreightAgreement',
            id: number
          } | {
            __typename?: 'GasolineAgreement',
            id: number
          } | {
            __typename?: 'GasolinePriceAgreement',
            id: number
          } | {
            __typename?: 'HoseRentalAgreement',
            id: number
          } | {
            __typename?: 'HourlyAgreement',
            id: number
          } | {
            __typename?: 'LumpsumAgreement',
            id: number
          } | {
            __typename?: 'MultiCargoAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'MultiOrderAdjustmentAgreement',
            id: number
          } | {
            __typename?: 'NitrogenPurgingAgreement',
            id: number
          } | {
            __typename?: 'OogAgreement',
            id: number
          } | {
            __typename?: 'PJKAgreement',
            id: number
          } | {
            __typename?: 'PostCalculationAgreement',
            id: number
          } | {
            __typename?: 'ReeferAgreement',
            id: number
          } | {
            __typename?: 'RentAgreement',
            id: number
          } | {
            __typename?: 'ReturnFreightDiscountAgreement',
            id: number
          } | {
            __typename?: 'ShipAgreement',
            id: number
          } | {
            __typename?: 'SupplementaryHeatingAgreement',
            id: number
          } | {
            __typename?: 'TeuAgreement',
            id: number
          } | {
            __typename?: 'TextAgreement',
            id: number
          } | {
            __typename?: 'WaterLevelAgreement',
            id: number
          } | {
            __typename?: 'WaterwayAgreement',
            id: number
          } | {
            __typename?: 'WeightAgreement',
            id: number
          } | {
            __typename?: 'WeightRangeAgreement',
            id: number
          }
        } | null> | null,
        invoiceLines: Array<{
          __typename?: 'InvoiceLine',
          id: number,
          linkedDeclarationValue?: {
            __typename?: 'DeclarationValue',
            id: number,
            quantity?: number | null,
            price?: number | null,
            agreement: {
              __typename?: 'AddressCommissionAgreement',
              id: number
            } | {
              __typename?: 'BlockFreightAgreement',
              id: number
            } | {
              __typename?: 'BunkerAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'CleaningAgreement',
              id: number
            } | {
              __typename?: 'CommissionAgreement',
              id: number
            } | {
              __typename?: 'DailyAgreement',
              id: number
            } | {
              __typename?: 'DangerousGoodAgreement',
              id: number
            } | {
              __typename?: 'DeadfreightAgreement',
              id: number
            } | {
              __typename?: 'DemurrageAgreement',
              id: number
            } | {
              __typename?: 'DemurrageCalculationAgreement',
              id: number
            } | {
              __typename?: 'FeetAgreement',
              id: number
            } | {
              __typename?: 'FreightAgreement',
              id: number
            } | {
              __typename?: 'GasolineAgreement',
              id: number
            } | {
              __typename?: 'GasolinePriceAgreement',
              id: number
            } | {
              __typename?: 'HoseRentalAgreement',
              id: number
            } | {
              __typename?: 'HourlyAgreement',
              id: number
            } | {
              __typename?: 'LumpsumAgreement',
              id: number
            } | {
              __typename?: 'MultiCargoAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'MultiOrderAdjustmentAgreement',
              id: number
            } | {
              __typename?: 'NitrogenPurgingAgreement',
              id: number
            } | {
              __typename?: 'OogAgreement',
              id: number
            } | {
              __typename?: 'PJKAgreement',
              id: number
            } | {
              __typename?: 'PostCalculationAgreement',
              id: number
            } | {
              __typename?: 'ReeferAgreement',
              id: number
            } | {
              __typename?: 'RentAgreement',
              id: number
            } | {
              __typename?: 'ReturnFreightDiscountAgreement',
              id: number
            } | {
              __typename?: 'ShipAgreement',
              id: number
            } | {
              __typename?: 'SupplementaryHeatingAgreement',
              id: number
            } | {
              __typename?: 'TeuAgreement',
              id: number
            } | {
              __typename?: 'TextAgreement',
              id: number
            } | {
              __typename?: 'WaterLevelAgreement',
              id: number
            } | {
              __typename?: 'WaterwayAgreement',
              id: number
            } | {
              __typename?: 'WeightAgreement',
              id: number
            } | {
              __typename?: 'WeightRangeAgreement',
              id: number
            }
          } | null
        }>
      } | null,
      agreements: Array<{
        __typename?: 'InvoiceGroupAgreement',
        agreement: {
          __typename?: 'AddressCommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'BlockFreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'BunkerAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'CleaningAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'CommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DailyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DangerousGoodAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DeadfreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DemurrageAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'DemurrageCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'FeetAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'FreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'GasolineAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'GasolinePriceAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'HoseRentalAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'HourlyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'LumpsumAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'MultiCargoAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'MultiOrderAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'NitrogenPurgingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'OogAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'PJKAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'PostCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'ReeferAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'RentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'ReturnFreightDiscountAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'ShipAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'SupplementaryHeatingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'TeuAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'TextAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WaterLevelAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WaterwayAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WeightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        } | {
          __typename?: 'WeightRangeAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          summary?: string | null,
          description?: string | null,
          hasFixedAmount: boolean,
          mayOverridePrice: boolean,
          calculateAmount?: number | null,
          costType?: {
            __typename?: 'CostType',
            id: number,
            title_en?: string | null,
            title_nl?: string | null,
            title_de?: string | null
          } | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            unit?: string | null,
            customUnit?: string | null
          } | null
        }
      }>
    }>
  }
};


export const CharterInvoiceGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"charterInvoiceGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"declarationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"declarationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"declarationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"closedOn"}},{"kind":"Field","name":{"kind":"Name","value":"financiallyReadiedOn"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceLineTableRow"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedDeclarationValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ready"}},{"kind":"Field","name":{"kind":"Name","value":"manualActionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceLineTableRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceIncVAT"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceReference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unexpected"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"calculationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactCharter"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactCharter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Charter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}}]}}]} as unknown as DocumentNode<CharterInvoiceGroupsQuery, CharterInvoiceGroupsQueryVariables>;
export const DeclarationLinesInvoiceGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeclarationLinesInvoiceGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Instant"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Instant"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"declarationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isDeclarable"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"declarationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"declarationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closedOn"}},{"kind":"Field","name":{"kind":"Name","value":"remark"}},{"kind":"Field","name":{"kind":"Name","value":"declarationValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"linkedDeclarationValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hasFixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"mayOverridePrice"}},{"kind":"Field","name":{"kind":"Name","value":"calculateAmount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"charterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"customUnit"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeclarationLinesInvoiceGroupsQuery, DeclarationLinesInvoiceGroupsQueryVariables>;